import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import React, { useMemo, useState } from 'react';

//Tables
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MyTable from '../../utils/MyTable';
//redux
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../../actions';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from '@material-ui/core/Tooltip';

import { unoTheme } from "../../../assets/styles/unoTheme";

import MyDatePicker from '../../utils/MyDatePicker';

import {
    applyMaskAccount,
    applyMaskAmount,
    applyMaskAmountFreeDecimals,
    formatPtStringDateToAnbimaDate,
    getAllPeriods,
    getDayMonthYearByDate,
    getDayMonthYearByPtDate,
    getFirstDateDayMonth,
    getLastDayInMonthByMonthAndYear,
    getMonthName,
    getNextPeriod,
    getPeriodBefore,
    isPeriodBefore,
    listPeriodsBetween,
    orderPeriods,
    stringPtDateToJsDate
} from '../../utils/utils';

import CircularProgress from '@material-ui/core/CircularProgress';

//Controllers
import { Divider, Menu, MenuItem, TableFooter } from '@material-ui/core';
import _ from 'lodash';
import moment from 'moment';
import { BalancesValidationsAPI } from '../../../API/balances_validations';
import { FundLocalQuotasAPI } from '../../../API/fund_local_quotas';
import { TransactionAPI } from '../../../API/transaction';
import UnoButton from '../../utils/UnoButton';

//Import excel
import XLSX from 'xlsx';
import { downloadBlob, s2ab } from "../../../controllers/ExcelController";
import { AccountAPI } from '../../../API/account';
import { ALL_REGIME_IDS, REGIME_SHEET_LABELS } from '../../utils/accountRegimes';
import { TitleLocalQuotasAPI } from '../../../API/title_local_quotas';
import { checkUserIsRole, roles } from '../../utils/user';

const useStyles = makeStyles((theme) => ({
    root: {
        //height: '100vh',
        width: '100%',
    },

    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: 'solid 0.5px #f4f4f4',

        background: unoTheme.hoverTable,

        '& .closeIcon': {
            padding: theme.spacing(3),
        }
    },

    main: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        height: "100%",

        '& .tableTransactions': {
            height: 'calc(100vh - 123px)',
        }

    },

    myDatePicker: {
        marginBottom: '16px',
    },

    labelCellTop: {
        fontSize: '13px',
        fontWeight: '600'
    },
    labelCellBottom: {
        fontSize: '13px',
        fontColor: unoTheme.defaultTextColor
    },

    bottom: {
        display: 'flex',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },

    buttonsBottom: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },

    noMarginTop: {
        marginTop: "0px",
    },

    hiddenIcon: {
        visibility: 'hidden',
    },

    rightDivBackdrop: {
        zIndex: 3,
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.85,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        color: unoTheme.mainColor,
        alignItems: 'center',
        justifyContent: 'center',

        '& .progress': {
            color: unoTheme.mainColor
        }
    },
    validationMessage: {
        color: unoTheme.errorColor,
        fontSize: '14px',
        textAlign: 'right',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },

    infosFundContent: {
        height: '100%',
        width: '100%',
        overflowY: 'scroll',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    leftHeader: {
        display: 'flex',
        padding: "24px",
        flexDirection: 'column',
        maxWidth: "calc(100% - 96px)"
    },

    fundLabel: {
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#1C2228',
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },

    cnpjLabel: {
        fontSize: '14px',
        color: unoTheme.secondaryColor,
    },

    overflowEllipsis: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    green: {
        color: unoTheme.greenMoney + ' !important'
    },
    red: {
        color: unoTheme.errorColor + ' !important',
    },
    blue: {
        color: 'blue !important',
    },

    warning: {
        color: unoTheme.warningColorStrong + ' !important',
        fontSize: '11px',
        fontWeight: '600',
    },

    blankLine: {

        '& .MuiTableCell-root': {
            color: 'transparent',
            borderBottom: 'unset',
            background: unoTheme.separatorTableRow,
        },

    },

    myTableFooter: {
        cursor: "pointer",
        borderBottom: 'unset',
        '& > *': {
            borderBottom: 'unset',
        },
        '& .MuiTableCell-root': {
            borderBottom: 'unset',
            color: 'white',
            background: unoTheme.mainColor,
        },

        '& .totalLineInvestiments': {
            '& .MuiTableCell-root': {
                color: 'black',
                borderBottom: 'unset',
                background: unoTheme.mainGrayColor,
            },
        },

        '& .MuiTableCell-root:first-child': {
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
            textWrap: 'nowrap'
        },

        '& .MuiTableCell-root:last-child': {
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
        },

        '& .spanTotal': {
            whiteSpace: 'nowrap'
        }
    },

}));

export default function IPC14(props) {

    const classes = useStyles();

    const dispatch = useDispatch();
    const clientOn = useSelector(state => state.clientOn)
    const currentUser = useSelector(state => state.currentUser)

    const { content } = props

    const [transactions, setTransactions] = useState([]);

    const [lines, setLines] = useState([]);

    const [messageBackdrop, setMessageBackdrop] = useState("");

    //MENU
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleOpenMenuReport = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenuReport = () => {
        setAnchorEl(null);
    };

    const [initDate, setInitDate] = useState(undefined);
    const [limitDate, setLimitDate] = useState(undefined);

    const [pasepTotal, setPasepTotal] = useState(0);

    const [selectedDate1, setSelectedDate1] = useState(undefined);

    const IS_PASEP_ON = useMemo(() => {
        if (!currentUser) return false;
        if (checkUserIsRole(currentUser, [roles.superadmin])) return true;
        return false;
    }, [currentUser]);

    const handleDateChange1 = (date) => {

        if (content?.isGeneralPASEP) {
            setSelectedDate1(date);
        } else {

            if (moment.utc(date).isBefore(initDate)) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: "A data deve estar entre " + moment.utc(initDate).format("MM/YYYY") + " e " + moment.utc(limitDate).format("MM/YYYY")
                }))

                setSelectedDate1(initDate);
            } else if (moment.utc(date).clone().startOf('month').isAfter(moment.utc(selectedDate2).clone().startOf('month'))) {
                //console.log("moment.utc(date): ", moment.utc(date).format("DD/MMM/YYYY"))
                //console.log("moment.utc(selectedDate2): ", moment.utc(selectedDate2).format("DD/MMM/YYYY"))
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: "A data inicial deve ser igual ou anterior a data final " + moment.utc(limitDate).format("MM/YYYY")
                }))

                setSelectedDate2(limitDate);
            } else {
                setSelectedDate1(date);
            }
        }
    };

    const [selectedDate2, setSelectedDate2] = useState(undefined);
    const handleDateChange2 = (date) => {

        if (content?.isGeneralPASEP) {
            setSelectedDate2(date);
        } else {

            if (moment.utc(date).isBefore(initDate)) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: "A data deve estar entre " + moment.utc(initDate).format("MM/YYYY") + " e " + moment.utc(limitDate).format("MM/YYYY")
                }))

                setSelectedDate2(limitDate);
            } else if (moment.utc(date).isBefore(moment.utc(selectedDate1))) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: "A data final deve ser igual ou posterior a data inicial " + moment.utc(limitDate).format("MM/YYYY")
                }))

                setSelectedDate2(limitDate);
            } else {
                setSelectedDate2(date);
            }
        }
    };

    const blankLine = {
        blankLine: true,
        date: "=",
        description: "=",
        amount: "=",
        qtdQuotas: "=",
        quotaValue: "=",
        balanceQuotas: "=",
        profit: "=",
        pasep: "",
        balanceApplicationsQuotas: "=",
    }

    const formatLinesReturnsIPC14 = async (selectedAsset, transactions, isGeneralReport) => {
        console.log("selectedAsset: ", selectedAsset);

        let currentBalanceQuotas = selectedAsset.isTitle ? parseFloat(selectedAsset.quantity_purchased) : parseFloat(selectedAsset.init_quotas);
        let currentBalance = selectedAsset.isTitle ?
            (parseFloat(selectedAsset.quantity_purchased) * parseFloat(selectedAsset.price_title))
            : parseFloat(selectedAsset.init_balance);

        const primaryValueQuotas = currentBalance / currentBalanceQuotas;

        const fullTransactionsArray = transactions.map((el) => ({
            date: moment.utc(el.transaction_date).format("DD/MM/YYYY"),
            amount: parseFloat(el.amount),
            operation_id: el.operation_id,
        }));

        console.log("FullTransactionsArray: ", fullTransactionsArray);

        const { month: lastDM, year: lastDY } = getDayMonthYearByPtDate(moment.utc(selectedAsset.asset_init).format("DD/MM/YYYY"));
        const lastDayM = getLastDayInMonthByMonthAndYear(lastDM, lastDY);

        fullTransactionsArray.unshift({
            date: lastDayM,
            amount: currentBalance,
            operation_id: 1,
            qtdQuotas: currentBalanceQuotas,
            quotaValue: currentBalance / currentBalanceQuotas,
        });

        const applicationsArray = _.cloneDeep(fullTransactionsArray.filter(el => el.operation_id === 1));
        const rescuesArray = fullTransactionsArray.filter(el => el.operation_id === 2);

        const allPeriods = [];
        let thePeriod = moment.utc(selectedAsset.asset_init).format("MM/YYYY");
        const endPeriod = clientOn.client.selectedPortfolioMonth.toString().padStart(2, "0") + "/" + clientOn.client.selectedPortfolioYear;

        const initDptDate = moment.utc(selectedAsset.asset_init).format('DD/MM/YYYY');
        const initD = stringPtDateToJsDate(initDptDate, true);

        const limitD = getFirstDateDayMonth(clientOn.client.selectedPortfolioMonth, clientOn.client.selectedPortfolioYear).date(1).toDate()

        //setSelectedDate1(initD)
        if (!isGeneralReport) {
            setSelectedDate1(limitD) //alterando para mês corrente
            setSelectedDate2(limitD)
        }

        setInitDate(initD)
        setLimitDate(limitD)

        let secureCount = 0;

        if (isPeriodBefore(thePeriod, endPeriod)) {
            while (thePeriod != endPeriod && secureCount != 999) {
                allPeriods.push(thePeriod);
                thePeriod = getNextPeriod(thePeriod, true);
                // console.log("thePeriod: ", thePeriod);
                secureCount++;
            }
            allPeriods.push(endPeriod);
        }

        const mapQuotasByPeriod = {};
        const mapBalancesByPeriod = {};

        console.log("All periods: ", allPeriods);
        if (allPeriods.length) {

            if (!selectedAsset.isTitle) {
                const response = await FundLocalQuotasAPI.getLocalQuotasByFundIdAndPeriods(selectedAsset.fund_id, allPeriods)
                if (response.success) {
                    response.body.forEach(quotas => {
                        mapQuotasByPeriod[`${quotas.month.toString().padStart(2, "0")}/${quotas.year}`] = JSON.parse(quotas.json_quotas);
                    });
                }
            } else {
                //TITLE_CASE
                const response = await TitleLocalQuotasAPI.getTitleLocalQuotasTitleByIdAndPeriods(selectedAsset.title_id, allPeriods)
                if (response.success) {
                    response.body.forEach(quotas => {
                        const rawQuotas = JSON.parse(quotas.json_quotas);
                        // Normalize title quotas { date_quota: "DD/MM/YYYY", pu_anb } to the same
                        // format used by fund quotas { data_referencia: "YYYY-MM-DD", valor_cota }
                        mapQuotasByPeriod[`${quotas.month.toString().padStart(2, "0")}/${quotas.year}`] = rawQuotas.map(q => ({
                            data_referencia: formatPtStringDateToAnbimaDate(q.date_quota),
                            valor_cota: q.pu_anb,
                        }));
                    });
                }
            }

            const responseBalances = selectedAsset.isTitle ?
                await BalancesValidationsAPI.getTitleAssetBalancesByPeriods(selectedAsset.id, allPeriods)
                :
                await BalancesValidationsAPI.getAssetBalancesByPeriods(selectedAsset.id, allPeriods);
            console.log("responseBalances: ", responseBalances);
            if (responseBalances.success) {
                responseBalances.body.forEach(balance => {
                    mapBalancesByPeriod[`${balance.period}`] = parseFloat(balance.balance);
                });
            }
        }




        console.log("mapQuotasByPeriod: ", mapQuotasByPeriod);
        console.log("mapBalancesByPeriod: ", mapBalancesByPeriod);

        const monetizedPeriods = [];

        const formattedLines = [];

        const getQuotaInfos = (amount, date, periodQuotas, theInit) => {

            if (!theInit) {
                let foundQuotaValue = null;

                if (periodQuotas && periodQuotas.length) {
                    const targetDate = formatPtStringDateToAnbimaDate(date);

                    // Exact date match, ignoring null valor_cota
                    const exact = periodQuotas.find(el => el.data_referencia === targetDate && el.valor_cota != null);
                    if (exact) {
                        foundQuotaValue = exact.valor_cota;
                    } else {
                        // Nearest prior date with valid valor_cota (weekend/holiday/null fallback)
                        const validPrior = periodQuotas.filter(el => el.data_referencia <= targetDate && el.valor_cota != null);
                        if (validPrior.length) {
                            foundQuotaValue = validPrior[validPrior.length - 1].valor_cota;
                        } else {
                            // Any valid quota in the period (e.g. rescue date before first quota of month)
                            const anyValid = periodQuotas.find(el => el.valor_cota != null);
                            if (anyValid) foundQuotaValue = anyValid.valor_cota;
                        }
                    }
                }

                // If the period has no valid quotas (e.g. post-maturity), fall back to
                // the most recent valid quota from any earlier period
                if (foundQuotaValue == null) {
                    const [tm, ty] = date.substring(3).split('/');
                    const targetNum = parseInt(ty) * 100 + parseInt(tm);
                    const sortedPeriods = Object.keys(mapQuotasByPeriod).sort((a, b) => {
                        const [am, ay] = a.split('/');
                        const [bm, by] = b.split('/');
                        return (parseInt(ay) * 100 + parseInt(am)) - (parseInt(by) * 100 + parseInt(bm));
                    });
                    for (let i = sortedPeriods.length - 1; i >= 0; i--) {
                        const p = sortedPeriods[i];
                        const [pm, py] = p.split('/');
                        if (parseInt(py) * 100 + parseInt(pm) >= targetNum) continue;
                        const quotas = mapQuotasByPeriod[p];
                        if (quotas && quotas.length) {
                            const valid = quotas.filter(el => el.valor_cota != null);
                            if (valid.length) { foundQuotaValue = valid[valid.length - 1].valor_cota; break; }
                        }
                    }
                }

                if (foundQuotaValue != null) {
                    return {
                        qtdQuotas: amount / foundQuotaValue,
                        quotaValue: foundQuotaValue,
                    };
                }
            }

            if (primaryValueQuotas) {
                return {
                    qtdQuotas: null,
                    quotaValue: primaryValueQuotas,
                };
            }

            return {
                qtdQuotas: null,
                quotaValue: null
            };
        }

        applicationsArray.forEach(app => {

            const { qtdQuotas, quotaValue } = getQuotaInfos(
                app.amount,
                app.date,
                mapQuotasByPeriod[app.date.substring(3)]
            );
            app.balanceQuotas = app.qtdQuotas ? app.qtdQuotas : qtdQuotas;

        });

        console.log("applicationsArray: ", applicationsArray);

        const getApplicationsToRescue = (rescueAmount, rescueQuotaValue) => {

            if (!rescueQuotaValue) return [];
            let currentRescueAmount = rescueAmount;
            const theApplicationsToRescue = [];
            for (let index = 0; index < applicationsArray.length; index++) {
                const application = applicationsArray[index];

                if (currentRescueAmount == 0) {
                    break;
                }

                //Caso ainda haja valor na aplicação
                if (application.amount > 0) {

                    //TITLE_CASE
                    //É necessário saber o valor da cota no dia para que seja corrigido o valor da aplicação
                    //Pois a aplicação já vai ter rendido no momento em que é feito o resgate 

                    application.amount = rescueQuotaValue * application.balanceQuotas;

                    //Caso a aplicação seja maior do que o valor descontado
                    if (application.amount > currentRescueAmount) {


                        //RESCUE_AMOUNT valor total do resgate
                        //FULL_QTD_QUOTAS quantidade de cotas do resgate
                        //CURRENT_RESCUE_AMOUNT valor que ainda falta resgatar

                        //TITLE_CASE                        
                        const qtdQuotasRescued = currentRescueAmount / rescueQuotaValue;
                        console.log("qtdQuotasRescued:", qtdQuotasRescued);

                        application.amount -= currentRescueAmount;
                        application.rescuedAmount = currentRescueAmount;
                        application.balanceQuotas -= qtdQuotasRescued;

                        if (application.amount.toString().startsWith("0.00")) {
                            application.amount = 0;
                            application.balanceQuotas = 0;
                            application.qtdQuotas = 0;
                        }


                        theApplicationsToRescue.push(application);

                        break;
                    } else {

                        //Caso a aplicação seja menor que o valor descontado
                        //É consumida toda a aplicação e o loop continua para as próximas aplicações
                        application.rescuedAmount = application.amount;
                        application.amount -= currentRescueAmount;
                        currentRescueAmount = application.amount * (-1);
                        if (currentRescueAmount.toString().startsWith("0.00")) {
                            currentRescueAmount = 0;
                        }
                        application.amount = 0;
                        application.balanceQuotas = 0;
                        theApplicationsToRescue.push(application);

                    }

                }
            }

            return theApplicationsToRescue;
        }

        // let currentPeriod = fullTransactionsArray[1].date.substring(3);
        // console.log("currentPeriod: ", currentPeriod);
        let beforePeriod = allPeriods[0];

        allPeriods.forEach((thePeriod, index) => {


            if (index !== 0) {

                const periodLoop = thePeriod;

                let totalApplicationAmountInPeriod = 0;
                let totalRescuesAmountInPeriod = 0;
                let totalAmortizationsAmountInPeriod = 0;

                const splittedBeforePeriod = beforePeriod.split("/");
                const lastDayBeforeMonth = getLastDayInMonthByMonthAndYear(parseInt(splittedBeforePeriod[0]), parseInt(splittedBeforePeriod[1]));

                const lastQuotaBeforeMonth = mapQuotasByPeriod[beforePeriod] && mapQuotasByPeriod[beforePeriod].length ? mapQuotasByPeriod[beforePeriod][mapQuotasByPeriod[beforePeriod].length - 1] : null;
                const lastQuotaNowMonth = mapQuotasByPeriod[periodLoop] && mapQuotasByPeriod[periodLoop].length ? mapQuotasByPeriod[periodLoop][mapQuotasByPeriod[periodLoop].length - 1] : null;
                //LINHA SALDO ANTERIOR
                formattedLines.push({
                    date: lastDayBeforeMonth,
                    description: "SALDO ANTERIOR",
                    amount: mapBalancesByPeriod[beforePeriod] ?? null,
                    qtdQuotas: currentBalanceQuotas,
                    quotaValue: "",
                    lastQuotaMonth: lastQuotaBeforeMonth?.valor_cota,
                    balanceQuotas: "",
                    profit: "",
                    pasep: "",
                    balanceApplicationsQuotas: "",
                    period: periodLoop
                });

                let profitPeriod = 0;
                let pasepPeriod = 0;

                //console.log("Period: ", periodLoop);
                //console.log(fullTransactionsArray.filter(el => el.date.substring(3) == periodLoop));
                let fullProfit = 0;
                fullTransactionsArray.filter(el => el.date.substring(3) == periodLoop &&
                    !el.quotaValue //removendo o saldo inicial
                ).forEach((transactionLoop, index) => {

                    const { operation_id } = transactionLoop;

                    if (operation_id === 1) { //APLICAÇÃO

                        console.log("transactionLoop APLICAÇÂO: ", transactionLoop);

                        currentBalance += transactionLoop.amount;
                        const { qtdQuotas, quotaValue } = getQuotaInfos(
                            transactionLoop.amount,
                            transactionLoop.date,
                            mapQuotasByPeriod[transactionLoop.date.substring(3)]
                        );
                        currentBalanceQuotas += qtdQuotas;

                        //LINHA DE APLICAÇÃO
                        formattedLines.push({
                            date: transactionLoop.date,
                            description: "APLICAÇÃO",
                            amount: transactionLoop.amount,
                            qtdQuotas: qtdQuotas,
                            quotaValue: quotaValue,
                            balanceQuotas: currentBalanceQuotas,
                            profit: "",
                            pasep: "",
                            balanceApplicationsQuotas: qtdQuotas,
                        });

                        //somando aplicações a serem utilizadas no cálculo de VPA e VPD
                        totalApplicationAmountInPeriod += transactionLoop.amount;

                    } else if (operation_id === 2) { //RESGATE

                        const rescuePeriod = transactionLoop.date.substring(3);

                        // console.log("rescue.date.substring(3): ", rescue.date.substring(3));
                        const { qtdQuotas, quotaValue } = getQuotaInfos(
                            transactionLoop.amount,
                            transactionLoop.date,
                            mapQuotasByPeriod[rescuePeriod]
                        );
                        // console.log("qtdQuotas, quotaValue: ", qtdQuotas, quotaValue);

                        //LINHA DE RESGATE
                        formattedLines.push({
                            date: transactionLoop.date,
                            description: "RESGATE",
                            amount: transactionLoop.amount,
                            qtdQuotas: qtdQuotas, //QTD DE COTAS DA OPERAÇÃO
                            quotaValue: quotaValue,
                            balanceQuotas: currentBalanceQuotas - qtdQuotas,
                            profit: "",
                            pasep: "",
                            balanceApplicationsQuotas: parseFloat(selectedAsset.init_quotas),
                        });

                        //somando resgates a serem utilizadas no cálculo de VPA e VPD
                        totalRescuesAmountInPeriod += transactionLoop.amount;

                        const theApplications = getApplicationsToRescue(transactionLoop.amount, quotaValue);

                        //console.log("theApplications: ", theApplications);

                        theApplications.forEach(application => {

                            ///console.log("RESCUED APPLICATION: ", application);

                            application.rescuedDate = transactionLoop.date;

                            const {
                                qtdQuotas: qtdQuotasApplication,
                                quotaValue: quotaValueInRescueDate
                            } = getQuotaInfos(
                                application.rescuedAmount,
                                transactionLoop.date,
                                mapQuotasByPeriod[rescuePeriod]
                            );

                            const {
                                qtdQuotas: _none,
                                quotaValue: quotaValueApplication
                            } = getQuotaInfos(
                                application.amount,
                                application.date,
                                mapQuotasByPeriod[application.date.substring(3)],
                                application.quotaValue ? true : false,
                            );

                            currentBalance -= application.rescuedAmount;
                            currentBalanceQuotas -= qtdQuotasApplication;

                            const profit = (quotaValue - quotaValueApplication) * qtdQuotasApplication;
                            const pasep = profit * 1 / 100;

                            profitPeriod += profit;
                            pasepPeriod += pasep;

                            //LINHA DE APLICAÇÃO RESGATADA
                            formattedLines.push({
                                date: "APPLICATION_",
                                description: "APLICAÇÃO " + application.date,
                                amount: application.rescuedAmount,
                                qtdQuotas: qtdQuotasApplication,
                                quotaValue: quotaValueApplication,
                                balanceQuotas: application.balanceQuotas,
                                profit: profit,
                                pasep: pasep,
                                period: periodLoop,
                                balanceApplicationsQuotas: parseFloat(selectedAsset.init_quotas),
                            });

                            //application.amount += profit;

                        });

                    } else {
                        //Amortizações
                        //somando amortizações a serem utilizadas no cálculo de VPA e VPD
                        //LINHA DE AMORTIZAÇÃO
                        formattedLines.push({
                            date: transactionLoop.date,
                            description: "AMORTIZAÇÃO",
                            amount: transactionLoop.amount,
                            qtdQuotas: 0,
                            quotaValue: 0,
                            balanceQuotas: 0,
                            profit: "",
                            pasep: "",
                            balanceApplicationsQuotas: 0,
                        });
                        totalAmortizationsAmountInPeriod += transactionLoop.amount;
                    }



                });

                /////////////////////////////
                //Fechando período mensal////
                /////////////////////////////      

                const splittedCurrentPeriod = periodLoop.split("/");
                const lastDayMonth = getLastDayInMonthByMonthAndYear(parseInt(splittedCurrentPeriod[0]), parseInt(splittedCurrentPeriod[1]));

                //LINHA SALDO ATUAL 
                const periodBalance = mapBalancesByPeriod[periodLoop] ?? null;
                // When the books say the balance is zero, display zero units regardless
                // of the running counter (handles missing redemption transactions at maturity)
                const displayBalanceQuotas = periodBalance === 0 ? 0 : currentBalanceQuotas;
                formattedLines.push({
                    date: lastDayMonth,
                    description: "SALDO ATUAL",
                    amount: periodBalance,
                    qtdQuotas: displayBalanceQuotas,
                    quotaValue: "",
                    lastQuotaMonth: lastQuotaNowMonth?.valor_cota,
                    balanceQuotas: displayBalanceQuotas,
                    profit: profitPeriod,
                    pasep: pasepPeriod,
                    balanceApplicationsQuotas: "",
                    period: periodLoop,
                    totalApplicationAmountInPeriod: totalApplicationAmountInPeriod,
                    totalRescuesAmountInPeriod: totalRescuesAmountInPeriod,
                    totalAmortizationsAmountInPeriod: totalAmortizationsAmountInPeriod,
                });

                // Reconcile running counters when balance definitively reached zero
                if (periodBalance === 0) {
                    currentBalance = 0;
                    currentBalanceQuotas = 0;
                }

                formattedLines.push(blankLine);
                //const periodsToRent = getPeriodsToRent(periodLoop);
                //console.log("periodsToRent: ", beforePeriod);

                //TITLE_CASE
                //Verificar necessidade desse método
                //doRentApplications(applicationsArray, beforePeriod, periodLoop);

                beforePeriod = periodLoop;

                /////////////////////////////
                /////////////////////////////

            }


        });

        // console.log("formattedLines: ", formattedLines);
        // console.log("formattedLines: ", formattedLines.filter(el => el.description.includes("APLICAÇÃO ")));
        return formattedLines;
    }

    // const loadTransactions = async (selectedAsset) => {

    //     setMessageBackdrop("Carregando movimentações...")
    //     const response = await getTransactionsByAsset(selectedAsset.id);

    //     console.log("response: ", response);
    //     if (response.success) {
    //         setTransactions(response.body.rows);
    //     }
    //     setLines(await formatLinesReturnsIPC14(selectedAsset, response.body.rows));
    // }

    const loadTransactions = async (selectedAsset, isGeneralReport) => {
        const response = selectedAsset.isTitle ?
            await TransactionAPI.getTransactionsByAssetTitle(selectedAsset.id)
            :
            await TransactionAPI.getTransactionsByAsset(selectedAsset.id)

        //console.log("response: ", response);
        if (response.success) {
            setTransactions(response.body.rows);
        }
        const lines = await formatLinesReturnsIPC14(selectedAsset, response.body.rows, isGeneralReport)
        if (!isGeneralReport) {

            //console.log("THE LINES: ", lines);
            setLines(lines);
        } else {
            //console.log("lines xxx: ", lines);
            return lines.filter(el => el.date == "APPLICATION_" || el.description == "SALDO ATUAL" || el.description == "SALDO ANTERIOR")

        }
    }

    const getLineRow = (row, index) => {

        if (row.monetized) {
            return <TableRow
                key={'asset-returns-ipc14-lines' + index}>

                <TableCell align="center">{row.date === 'APPLICATION_' ? "" : row.date}</TableCell>
                <TableCell align="right">{row.lastQuotaPeriod}</TableCell>
                <TableCell align="left">{" x "}</TableCell>
                <TableCell align="left">{applyMaskAmount(row.balanceQuotas)}</TableCell>
                <TableCell align="left">{"="}</TableCell>
                <TableCell align="left">{applyMaskAmount(row.resultAmount, true)}</TableCell>
                <TableCell align="left">{""}</TableCell>
                {
                    IS_PASEP_ON ?
                        <TableCell align="right">{""}</TableCell> : null
                }
                {/* <TableCell align="center">{row.balanceApplicationsQuotas ? applyMaskAmount(row.balanceApplicationsQuotas) : ""}</TableCell> */}


            </TableRow>
        } else {
            return <TableRow
                key={'asset-returns-ipc14-lines' + index}>

                <TableCell align="center">{row.date === 'APPLICATION_' ? "" : row.date}</TableCell>
                <TableCell align="left">{row.description}</TableCell>
                <TableCell align="right" className={row.description == "RESGATE" ? classes.red : (row.description == "AMORTIZAÇÃO" ? classes.blue : classes.green)}>
                    {row.amount != null && !isNaN(row.amount)
                        ? applyMaskAmount(row.amount, true)
                        : (row.amount === null && row.description && row.description.startsWith("SALDO")
                            ? <Tooltip title="Saldo não disponível após o vencimento do título">
                                <span className={classes.warning}>Vencido</span>
                            </Tooltip>
                            : "")}
                </TableCell>
                <TableCell align="right">{row.qtdQuotas ? applyMaskAmount(row.qtdQuotas) : ""}</TableCell>
                <TableCell align="right">{row.quotaValue ? applyMaskAmountFreeDecimals(row.quotaValue, null, 5) : ""}</TableCell>
                <TableCell align="right" className={row.description.includes("APLICAÇÃO") && row.profit ? classes.blue : ""}>{row.balanceQuotas ? applyMaskAmount(row.balanceQuotas) : ""}</TableCell>
                <TableCell align="right">{row.profit ? applyMaskAmount(row.profit, true) : ""}</TableCell>
                {
                    IS_PASEP_ON ?
                        <TableCell align="right">{row.pasep ? applyMaskAmount(row.pasep, true) : ""}</TableCell> : null
                }
                {/* <TableCell align="center">{row.balanceApplicationsQuotas ? applyMaskAmount(row.balanceApplicationsQuotas) : ""}</TableCell> */}


            </TableRow>

        }
    }

    const filteredReportLines = useMemo(() => {

        if (lines?.length === 0 || !selectedDate1 || !selectedDate2) return [];

        const { data: asset } = content;

        const sd1 = moment.utc(selectedDate1).subtract(1, 'months').format("M/YYYY");
        const sd2 = moment.utc(selectedDate2).format("M/YYYY");
        const initPeriodAsset = moment.utc(asset.asset_init).format("MM/YYYY");
        const selectedPeriodsYearMap = getAllPeriods(sd1, sd2);
        const selectedPeriodsYearArray = [];
        let firstPeriod = null;
        Object.entries(selectedPeriodsYearMap).map(([year, periodsInYear]) => {
            periodsInYear.forEach(element => {
                if (!firstPeriod) firstPeriod = element.toString().padStart(7, '0');
                selectedPeriodsYearArray.push(element.toString().padStart(7, '0'));
            });

        })

        //console.log("First period: ", firstPeriod);
        const periodBefore = initPeriodAsset == firstPeriod ? firstPeriod : getPeriodBefore(firstPeriod).padStart(7, '0');
        //console.log("Period before: ", periodBefore);

        const indexOfFirstLine = lines.findIndex(el => el.description == "SALDO ANTERIOR"
            && el.date.includes(periodBefore)
        )

        const filteredReportLines = lines.slice(indexOfFirstLine);

        //console.log("filteredReportLines: ", filteredReportLines);

        setMessageBackdrop("")

        // console.log("PASEPS: ", filteredReportLines.map(el => el.pasep));
        const pTotal = filteredReportLines.reduce(
            (previous, current) => previous + (current.description == "SALDO ATUAL" && current.pasep ? parseFloat(current.pasep) : 0),
            0
        );
        setPasepTotal(pTotal < 0 ? 0 : pTotal);

        return filteredReportLines;
        //return [];

    }, [lines, selectedDate1, selectedDate2])

    function doReportExcel(filteredReportLines) {

        const { data: asset } = content;

        setMessageBackdrop("Gerando planilha...")

        const assetLabel = asset.fund_name + "_CC:" + applyMaskAccount(asset.number_account) + "_Ag:" + asset.agency;
        const fileName = "Retornos_IPC14_" + assetLabel + "_" + moment.utc(selectedDate1).format("MM_YYYY") + "_" + moment.utc(selectedDate2).format("MM_YYYY");

        const wb = XLSX.utils.book_new();
        wb.Props = {
            Title: fileName,
            Author: "UNO",
        }

        const sheetName = "Retornos_IPC14";
        wb.SheetNames.push(sheetName);

        const ws_data = [];

        ws_data.push([
            'DATA',
            'DESCRIÇÃO',
            'VALOR',
            'QTD. COTAS',
            'VALOR COTA',
            "SALDO COTAS",
            "RECEITA ORÇAMENTÁRIA",
        ])

        if (IS_PASEP_ON) {
            ws_data[0].push("PASEP");
        }


        filteredReportLines.forEach((row, index) => {
            if (row.blankLine) {
                ws_data.push([
                    "-",
                    "-",
                    "-",
                    "-",
                    "-",
                    "-",
                    "-"

                ])
                if (IS_PASEP_ON) {
                    ws_data[index].push("PASEP");
                }
            } else {
                ws_data.push([
                    row.date == "APPLICATION_" ? "" : row.date,//date: 
                    row.description,
                    row.amount ? applyMaskAmount(row.amount, true) : "-",//amount: 
                    row.qtdQuotas ? applyMaskAmount(row.qtdQuotas) : "-",//qtdQuotas:
                    row.quotaValue ? applyMaskAmountFreeDecimals(row.quotaValue, null, 5) : "-",//quotaValue:
                    row.balanceQuotas ? applyMaskAmount(row.balanceQuotas) : "-",//balanceQuotas:
                    row.profit ? applyMaskAmount(row.profit, true) : "-",//profit:
                ])
                if (IS_PASEP_ON) {
                    ws_data[index].push(row.pasep ? applyMaskAmount(row.pasep, true) : "-"); //pasep
                }
            }

        });

        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        wb.Sheets[sheetName] = ws;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

        downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName + '.xlsx');

        handleCloseMenuReport()
        setMessageBackdrop("")
    }

    function doReportGeneralExcel(lines, startDate, endDate) {
        const { data: asset } = content;

        setMessageBackdrop("Gerando planilha...");

        const fileName = `Retornos_Gerais_IPC14_${moment(startDate).format('MM_YYYY')}_${moment(endDate).format('MM_YYYY')}`;

        const wb = XLSX.utils.book_new();
        wb.Props = {
            Title: fileName,
            Author: "UNO",
        };

        ALL_REGIME_IDS.forEach(regimeId => {
            //sheetLabel: sem acento e dentro do limite de 31 caracteres do XLSX
            const sheetName = REGIME_SHEET_LABELS[regimeId];

            const header = ['MÊS', 'RECEITA ORÇAMENTÁRIA', 'VPA', 'VPD'];
            if (IS_PASEP_ON) header.push('PASEP');
            header.push("SALDO ANTERIOR", "SALDO ATUAL", "CALC VPA/VPD");

            const ws_data = [header];

            lines.filter(el => el.segregationCod == regimeId).forEach(row => {
                if (row.lineType == 'divider_period') {

                    const dataRow = [
                        row.month,
                        row.profit,
                        row.vpa,
                        row.vpd,
                    ];
                    if (IS_PASEP_ON) dataRow.push(row.pasep);
                    ws_data.push(dataRow);
                } else {

                    const dataRow = [
                        row.month,
                        row.profit != null ? row.profit : "-",
                        row.vpa != null ? row.vpa : "-",
                        row.vpd != null ? row.vpd : "-",
                    ];
                    if (IS_PASEP_ON) dataRow.push(row.pasep != null ? row.pasep : "-");
                    dataRow.push(
                        row.balanceBefore != null ? row.balanceBefore : "-",
                        row.balanceNow != null ? row.balanceNow : "-",
                        row.calcVpaVpd != null ? row.calcVpaVpd : "",
                    );
                    ws_data.push(dataRow);
                }
            });

            const ws = XLSX.utils.aoa_to_sheet(ws_data);

            // Aplicar formato contábil nas colunas numéricas (B até SALDO ATUAL)
            // Com PASEP: B(1) até G(6); sem PASEP: B(1) até F(5)
            const lastNumericCol = IS_PASEP_ON ? 6 : 5;
            const range = XLSX.utils.decode_range(ws['!ref']);
            for (let R = 1; R <= range.e.r; ++R) {
                for (let C = 1; C <= lastNumericCol; ++C) {
                    const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                    if (!ws[cellAddress]) continue;

                    const cellValue = ws[cellAddress].v;
                    if (typeof cellValue === 'number') {
                        ws[cellAddress].t = 'n';
                        ws[cellAddress].z = '_-R$ * #,##0.00_-;_-R$ * -#,##0.00_-;_-R$ * "-"??_-;_-@_-';
                    }
                }
            }

            XLSX.utils.book_append_sheet(wb, ws, sheetName);
        });

        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName + '.xlsx');

        setMessageBackdrop("");

        dispatch(allActions.rightContentActions.setRightContent(null))
    }


    function timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const loadAllPASEP = async (allAssets) => {

        dispatch(allActions.fullLoadActions.setFullLoad({
            show: true,
            message: "Processando informações..."
        }))


        console.log("selectedDate1: ", selectedDate1);
        const copyDate = moment.utc(selectedDate1).clone();
        const { month: mStart, year: yStart } = getDayMonthYearByDate(copyDate.subtract(1, 'months'));
        const { month: mEnd, year: yEnd } = getDayMonthYearByDate(selectedDate2);
        const endDayStartPeriod = getLastDayInMonthByMonthAndYear(mStart, yStart);
        const endDayEndPeriod = getLastDayInMonthByMonthAndYear(mEnd, yEnd);

        const allResponses = {};
        //for (let index = 0; index < 10; index++) {
        for (let index = 0; index < allAssets.length; index++) {

            await timeout(1000);
            const asset = allAssets[index];
            const cod = asset.cnpj;
            if (!allResponses[cod]) {
                allResponses[cod] = {
                    assetInfo: { ...asset },
                    accounts: {},
                }
            }
            const lines = await loadTransactions(asset, true);

            //console.log("ASSET: ", asset);
            if (!allResponses[cod].accounts[asset.account_regime_id]) {
                allResponses[cod].accounts[asset.account_regime_id] = {};
            }

            //formattando lines por período 
            const uniquePeriodsInLines = [];
            lines.forEach(element => {
                if (element.period && !uniquePeriodsInLines.includes(element.period)) {
                    uniquePeriodsInLines.push(element.period);
                }
            });
            const linesByPeriod = {};
            uniquePeriodsInLines.forEach((el) => {
                //console.log("LINES APPLICATION: ", lines.filter(l => l.date == "APPLICATION_" && l.period == el));
                //linesByPeriod[el] = lines.filter(l => l.period == el);
                linesByPeriod[el] = lines.filter(l => l.period == el);
            })

            allResponses[cod].accounts[asset.account_regime_id][asset.account_id] = linesByPeriod;

            dispatch(allActions.fullLoadActions.setFullLoad({
                show: true,
                message: `Processando informações... (${(index + 1)}/${allAssets.length} Ativos)`
            }))

            //console.log("allResponse: ", allResponses);
        }

        dispatch(allActions.fullLoadActions.setFullLoad({
            show: false,
        }))

        doReportGeneral(allResponses);

    }

    const doReportGeneral = async (obj) => {

        console.log("THE OBJ: ", obj);

        //Formatando no layout sugerido
        //------------------------------------------------------------------------------------------------------------
        //Mês	        Receita orçamentária	VPA	                    VPD	                    Pasep
        //------------------------------------------------------------------------------------------------------------
        //Janeiro/25	Total Mês1=A1+B1+...	Total Mês1=A1+B1+...	Total Mês1=A1+B1+...	Total Mês1=A1+B1+...
        //Conta XXXXXX	A1 = i+ii+iii	        A1 = i+ii+iii	        A1 = i+ii+iii	        A1 = i+ii+iii
        //Fundo A	    i	                    i	                    i	                    i
        //Fundo B	    Ii	                    Ii	                    Ii	                    Ii
        //Fundo C	    Iii	                    Iii	                    Iii	                    Iii
        //------------------------------------------------------------------------------------------------------------
        //Conta YYYYYY	B1 = i+ii+iii	        B1 = i+ii+iii	        B1 = i+ii+iii	        B1 = i+ii+iii
        //Fundo A	    i	                    i	                    i	                    i
        //Fundo B	    Ii	                    Ii	                    Ii	                    Ii
        //Fundo C	    Iii	                    Iii	                    Iii	                    Iii

        const fullObjToReport = {
            1: {},
            2: {},
            3: {},
            4: {},
        }

        const mapAssetInfoByCnpj = {};

        const thePeriods = listPeriodsBetween(moment.utc(selectedDate1).format('MM/YYYY'), moment.utc(selectedDate2).format('MM/YYYY'))
        //Formatando por período
        Object.entries(obj).map(([cnpj, accountsByRegimeAndAssetInfo]) => {

            ///console.log("accountsByRegimeAndAssetInfo: ", accountsByRegimeAndAssetInfo);
            const { accounts: accountsByRegime, assetInfo } = accountsByRegimeAndAssetInfo;
            if (!mapAssetInfoByCnpj[cnpj]) {
                mapAssetInfoByCnpj[cnpj] = {
                    fundName: assetInfo.fund_name,
                }
            }
            Object.entries(accountsByRegime).map(([accountRegimeId, accs]) => {
                Object.entries(accs).map(([accountId, periodsInAccount]) => {

                    const orderedPeriods = orderPeriods(Object.keys(periodsInAccount));
                    console.log("fullObjToReport: ", fullObjToReport);
                    console.log("accountRegimeId: ", accountRegimeId);
                    console.log("accountId: ", accountId);
                    if (!fullObjToReport[accountRegimeId][accountId]) {
                        fullObjToReport[accountRegimeId][accountId] = {};
                    }

                    orderedPeriods.forEach(element => {
                        if (thePeriods.includes(element)) {

                            if (!fullObjToReport[accountRegimeId][accountId][element]) {
                                fullObjToReport[accountRegimeId][accountId][element] = {};
                            }

                            fullObjToReport[accountRegimeId][accountId][element][assetInfo.cnpj] = periodsInAccount[element]
                        }

                    });
                });
            });
        });


        const finalLinesToReport = [];

        const accountsIdsToInfo = [];

        //Laço de segregações
        ALL_REGIME_IDS.forEach((segregationCod) => {

            let totalProfitSecregation = 0;
            let totalPasepSecregation = 0;
            let totalVPASecregation = 0;
            let totalVPDSecregation = 0;

            thePeriods.forEach((period) => {

                const splittedPeriod = period.split("/");
                finalLinesToReport.push({
                    //TYPE LINE
                    lineType: "divider_period",
                    month: `=`,
                    profit: `=`,
                    pasep: `=`,
                    vpa: `=`,
                    vpd: `=`,
                    segregationCod: segregationCod,
                })
                finalLinesToReport.push({
                    //TYPE LINE
                    lineType: "month_totals",
                    month: `${getMonthName(parseInt(splittedPeriod[0]))}/${splittedPeriod[1]}`,
                    profit: 0,
                    pasep: 0,
                    vpa: 0,
                    vpd: 0,
                    segregationCod: segregationCod,
                })

                const monthInLoop = finalLinesToReport[finalLinesToReport.length - 1];

                if (fullObjToReport[segregationCod]) {

                    Object.entries(fullObjToReport[segregationCod]).map(([accountId, periodsWithCnpjs]) => {

                        if (!accountsIdsToInfo.includes(accountId)) accountsIdsToInfo.push(accountId);

                        finalLinesToReport.push({
                            //TYPE LINE
                            lineType: "acc",
                            month: accountId,
                            profit: 0,
                            pasep: 0,
                            vpa: 0,
                            vpd: 0,
                            segregationCod: segregationCod,
                            accOn: false,
                        });

                        let sumProfitAcc = 0;
                        let sumPasepAcc = 0;
                        let sumVpaAcc = 0;
                        let sumVpdAcc = 0;

                        const accInLoop = finalLinesToReport[finalLinesToReport.length - 1];

                        //console.log("periodsWithCnpjs: ", periodsWithCnpjs);
                        if (periodsWithCnpjs[period]) {
                            Object.entries(periodsWithCnpjs[period]).map(([cnpj, linesInPeriod]) => {

                                //console.log("linesInPeriod: ", linesInPeriod);

                                const balancesBeforeInPeriod = linesInPeriod.find(el => el.description == "SALDO ANTERIOR");
                                const balancesNowInPeriod = linesInPeriod.find(el => el.description == "SALDO ATUAL");

                                //console.log("balancesBeforeInPeriod: ", balancesBeforeInPeriod);
                                //console.log("balancesNowInPeriod: ", balancesNowInPeriod);
                                const application_Lines = linesInPeriod.filter(el => el.date == "APPLICATION_");

                                // VPA e VPD independem de movimentações
                                //Checar se houove alguma movimentação ou saldo nesse período
                                if (
                                    balancesNowInPeriod.amount
                                    || balancesNowInPeriod.totalApplicationAmountInPeriod
                                    || balancesNowInPeriod.totalRescuesAmountInPeriod
                                    || balancesNowInPeriod.totalAmortizationsAmountInPeriod
                                    || balancesBeforeInPeriod.amount
                                ) {

                                    //Calcular totais do fundo no período
                                    const sumProfit = application_Lines.reduce(
                                        (previous, current) => previous + parseFloat(current.profit),
                                        0
                                    )
                                    sumProfitAcc += sumProfit;
                                    const sumPasep = application_Lines.reduce(
                                        (previous, current) => previous + parseFloat(current.pasep),
                                        0
                                    )
                                    sumPasepAcc += sumPasep;

                                    //Adicionar aqui VPA E VPD
                                    let theVPA = 0;
                                    let theVPD = 0;
                                    //se FINAL < INICIAL vpd
                                    console.log("balancesNowInPeriod: ", balancesNowInPeriod);
                                    let lastQuotaMonthNow = null;
                                    let lastQuotaMonthBefore = null;
                                    if (balancesNowInPeriod && balancesBeforeInPeriod) {

                                        const result = (balancesNowInPeriod.amount ?? 0)
                                            - (balancesNowInPeriod.totalApplicationAmountInPeriod ?? 0)
                                            + (
                                                (balancesNowInPeriod.totalRescuesAmountInPeriod ?? 0)
                                                + (balancesNowInPeriod.totalAmortizationsAmountInPeriod ?? 0)
                                            )
                                            - (balancesBeforeInPeriod.amount ?? 0);

                                        if (result < 0) {
                                            theVPD = result;
                                            sumVpdAcc += theVPD;
                                        } else {
                                            theVPA = result;
                                            sumVpaAcc += theVPA;
                                        }
                                    }

                                    //console.log("theVPD: ", theVPD, theVPA);

                                    finalLinesToReport.push({
                                        //TYPE LINE
                                        lineType: "fund",
                                        month: mapAssetInfoByCnpj[cnpj].fundName,
                                        profit: sumProfit,
                                        pasep: sumPasep,
                                        vpa: theVPA,
                                        vpd: theVPD,
                                        lastQuotaMonthNow: lastQuotaMonthNow,
                                        lastQuotaMonthBefore: lastQuotaMonthBefore,
                                        calcVpaVpd: `${balancesNowInPeriod.amount} [SALDO FINAL] - ${balancesNowInPeriod.totalApplicationAmountInPeriod} [APLICAÇÕES NO PERÍODO] + ${balancesNowInPeriod.totalRescuesAmountInPeriod} [RESGATES NO PERÍODO] - ${balancesBeforeInPeriod.amount} [SALDO INICIAL]`,
                                        segregationCod: segregationCod,
                                        balanceBefore: balancesBeforeInPeriod ? balancesBeforeInPeriod.amount : null,
                                        balanceNow: balancesNowInPeriod ? balancesNowInPeriod.amount : null,
                                    });

                                    accInLoop.accOn = true;

                                }



                            });
                        }

                        accInLoop.profit = sumProfitAcc;
                        accInLoop.pasep = sumPasepAcc;
                        accInLoop.vpa = sumVpaAcc;
                        accInLoop.vpd = sumVpdAcc;
                        //Adicionar aqui VPA E VPD

                        monthInLoop.profit += accInLoop.profit;
                        monthInLoop.pasep += accInLoop.pasep;
                        monthInLoop.vpa += accInLoop.vpa;
                        monthInLoop.vpd += accInLoop.vpd;

                        totalProfitSecregation += accInLoop.profit;
                        totalPasepSecregation += accInLoop.pasep;
                        totalVPASecregation += accInLoop.vpa;
                        totalVPDSecregation += accInLoop.vpd;
                    });
                }



            })

            finalLinesToReport.push({
                //TYPE LINE
                lineType: "divider_period",
                month: "=",
                profit: '=',
                pasep: '=',
                vpa: '=',
                vpd: '=',
                segregationCod: segregationCod,
            });

            finalLinesToReport.push({
                //TYPE LINE
                lineType: "total",
                month: "Total",
                profit: totalProfitSecregation,
                pasep: totalPasepSecregation,
                vpa: totalVPASecregation,
                vpd: totalVPDSecregation,
                segregationCod: segregationCod,
            });
        })


        const responseAccountsByIds = await AccountAPI.getAccountsByIds(accountsIdsToInfo);
        const mapAccountById = {};
        if (responseAccountsByIds.success) {

            responseAccountsByIds.body.rows.forEach(element => {
                mapAccountById[element.id] = `CC: ${applyMaskAccount(element.number_account)}${element.agency ? ' / Ag: ' + element.agency : ''}`
            });
        }

        console.log("thePeriods: ", thePeriods);

        console.log("fullObjToReport: ", fullObjToReport);
        console.log("mapAssetInfoByCnpj: ", mapAssetInfoByCnpj);

        console.log("finalLinesToReport1: ", finalLinesToReport)

        let currentAcc = null;

        const normalizedLines = [];
        //Removendo contas que não houveram operações em fundos
        // finalLinesToReport.forEach((element, index) => {
        //     if (element.lineType == 'acc' && currentAcc != element.month) {
        //         currentAcc = element.month;

        //         //Removendo conta que não apresentou movimentações no período
        //         if (normalizedLines[normalizedLines.length - 1]?.lineType == 'acc') {
        //             normalizedLines.pop();
        //         }
        //     }

        //     if (finalLinesToReport[index] && finalLinesToReport[index].lineType == "month_totals") {
        //         //não incluir a conta sem movimentações
        //     } else {
        //         normalizedLines.push(element);
        //     }


        // });

        //Normalizando exibição de contas
        finalLinesToReport.filter(el => el.lineType == 'acc').forEach(element => {
            element.month = "    " + mapAccountById[element.month];
        });

        finalLinesToReport.filter(el => el.lineType == 'fund').forEach(element => {
            element.month = "        " + element.month;
        });

        doReportGeneralExcel(finalLinesToReport.filter(el => el.lineType != 'acc' || (el.lineType == 'acc' && el.accOn == true)), selectedDate1, selectedDate2);

    }

    function doReportPdf(filteredReportLines) {

        const { data: asset } = content;

        const finalLines = filteredReportLines.map(row => {

            //console.log("ROW: ", row);
            if (row.blankLine) {
                return {
                    ...row,
                };
            }

            return {
                ...row,
                date: row.date == "APPLICATION_" ? "" : row.date,
                amount: row.amount ? applyMaskAmount(row.amount, true) : "-",
                qtdQuotas: row.qtdQuotas ? applyMaskAmount(row.qtdQuotas) : "-",
                quotaValue: row.quotaValue ? applyMaskAmountFreeDecimals(row.quotaValue, null, 5) : "-",
                balanceQuotas: row.balanceQuotas ? applyMaskAmount(row.balanceQuotas) : "-",
                profit: row.profit ? applyMaskAmount(row.profit, true) : "-",
                ...(IS_PASEP_ON && { pasep: row.pasep ? applyMaskAmount(row.pasep, true) : "-" }),
            }

        })

        if (IS_PASEP_ON) {
            finalLines.push({
                date: "PASEP TOTAL",
                description: "",
                amount: "",
                qtdQuotas: "",
                quotaValue: "",
                balanceQuotas: "",
                profit: "",
                pasep: applyMaskAmount(pasepTotal, true),
            })
        }

        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            reportType: 'ipc14_returns',
            message: 'Gerando relatório...',
            reportData: {
                isPasepOn: IS_PASEP_ON,
                asset: asset.fund_name + " - CC: " + applyMaskAccount(asset.number_account) + " Ag: " + asset.agency,
                lines: finalLines
            }
        }))

        handleCloseMenuReport()
    }

    const doGeneralReport = () => {

        const { data: allAssets } = content;
        //console.log("allAssets: ", allAssets);
        loadAllPASEP(allAssets);
    }

    useState(() => {
        if (content?.data) {

            if (content?.isGeneralPASEP) {

                //esperar seleção de período e clique no botão central de geraçao de relatório
                const limitD = getFirstDateDayMonth(clientOn.client.selectedPortfolioMonth, clientOn.client.selectedPortfolioYear).date(1).toDate();
                setSelectedDate1(limitD)
                setSelectedDate2(limitD)

            } else {

                console.log("PASSANDO LOAD TRANSACTIONS USEEFFECT");
                const { data: asset } = content;
                loadTransactions(asset)
            }
        }
    }, [])

    return (
        <div className={classes.root}>

            <Paper elevation={0}>
                <div className={classes.header}>

                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

                        <div className={classes.leftHeader}>

                            <Typography
                                align={'left'}
                                style={{ color: unoTheme.secondaryColor }}>
                                IPC14
                            </Typography>
                            {
                                !content?.isGeneralPASEP &&
                                <Typography
                                    align={'left'}
                                    className={classes.fundLabel}>
                                    {content?.data?.fund_name ?? ""}

                                </Typography>
                            }

                            {
                                !content?.isGeneralPASEP &&
                                <Typography
                                    align={'left'}
                                    className={classes.cnpjLabel}>
                                    {content?.data?.cnpj ?? ""}
                                    <span style={{ marginLeft: "12px" }}>CC: {content?.data?.number_account ? applyMaskAccount(content.data.number_account) : "-"}</span>
                                    <span style={{ marginLeft: "12px" }}>Ag: {content?.data?.agency ?? "-"}</span>
                                </Typography>
                            }
                        </div>

                        <MyDatePicker
                            verySmall
                            outerlabel="Início do período"
                            id="ipca14-date-1"
                            disabled={!lines?.length && !content?.isGeneralPASEP}
                            views={["month", "year"]}
                            margin="dense"
                            format="MM/YYYY"
                            KeyboardButtonProps={{ 'aria-label': 'change date', }}
                            value={selectedDate1}
                            onChange={handleDateChange1}
                            style={{ marginRight: '16px' }}
                        />

                        <MyDatePicker
                            verySmall
                            outerlabel="Fim do período"
                            id="ipca14-date-2"
                            disabled={!lines?.length && !content?.isGeneralPASEP}
                            views={["month", "year"]}
                            margin="dense"
                            format="MM/YYYY"
                            KeyboardButtonProps={{ 'aria-label': 'change date', }}
                            value={selectedDate2}
                            onChange={handleDateChange2}
                            style={{ marginRight: '16px' }}
                        />

                        {content?.isGeneralPASEP ?
                            null
                            :
                            <div>
                                <UnoButton
                                    disabled={!lines?.length}
                                    isIconButton
                                    onClick={handleOpenMenuReport}
                                    size='small'
                                    type='primary'
                                />

                                <Menu
                                    id="articles-report-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={handleCloseMenuReport}
                                >
                                    <MenuItem onClick={() => doReportPdf(filteredReportLines)}>PDF</MenuItem>
                                    <MenuItem onClick={() => doReportExcel(filteredReportLines)}>Excel</MenuItem>
                                </Menu>

                            </div>
                        }

                        {/* <UnoButton
                            style={{ marginRight: '16px' }}
                            size={'small'}
                            onClick={() => doReport(lines, true)}
                            type='success'
                            disabled={!lines?.length}
                            startIcon={<PrintIcon />}>
                            {"Gerar resumido"}
                        </UnoButton> */}
                    </div>



                    <IconButton className="closeIcon" onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                        <CloseIcon />
                    </IconButton>

                </div>
            </Paper>

            <Divider />
            <div className={classes.main}>
                {
                    content?.isGeneralPASEP ?
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}>
                            <UnoButton
                                size={'small'}
                                type='primary'
                                onClick={() => doGeneralReport()}>
                                {`Gerar relatório [ ${moment.utc(selectedDate1).format("MM/YYYY")} ] a [ ${moment.utc(selectedDate2).format("MM/YYYY")} ]`}
                            </UnoButton>
                        </div>
                        :
                        <div className='tableTransactions'>
                            <MyTable stickyHeader
                                selectable
                                size="small">
                                <colgroup>
                                    <col width="10%" />
                                    <col width="15%" />
                                    {/*<col width="10%" />
                            <col width="10%" />
                            <col width="10%" /> */}
                                </colgroup>
                                <TableHead>
                                    <TableRow>

                                        <TableCell align="center">DATA</TableCell>
                                        <TableCell align="left">DESCRIÇÃO</TableCell>
                                        <TableCell align="right">VALOR</TableCell>
                                        <TableCell align="right">QUANTIDADE DE COTAS</TableCell>
                                        <TableCell align="right">VALOR COTA</TableCell>
                                        <TableCell align="right">SALDO COTAS</TableCell>
                                        <TableCell align="right">RECEITA ORÇAMENTÁRIA</TableCell>
                                        {
                                            IS_PASEP_ON ?
                                                <TableCell align="right">PASEP</TableCell> : null
                                        }
                                        {/* <TableCell align="center">SALDO DAS APLICAÇÕES</TableCell> */}

                                    </TableRow>
                                </TableHead>


                                <TableBody>
                                    {filteredReportLines.map((row, index) => row.blankLine ?
                                        (<TableRow
                                            className={classes.blankLine}
                                            key={'asset-returns-ipc14-lines' + index}>

                                            <TableCell align="center">-</TableCell>
                                            <TableCell align="center">-</TableCell>
                                            <TableCell align="center">-</TableCell>
                                            <TableCell align="center">-</TableCell>
                                            <TableCell align="center">-</TableCell>
                                            <TableCell align="center">-</TableCell>
                                            <TableCell align="center">-</TableCell>
                                            {
                                                IS_PASEP_ON ?
                                                    <TableCell align="center">-</TableCell> : null
                                            }

                                            {/* <TableCell align="center">{row.balanceApplicationsQuotas ? applyMaskAmount(row.balanceApplicationsQuotas) : ""}</TableCell> */}


                                        </TableRow>)
                                        :
                                        (
                                            getLineRow(row, index)
                                        ))}
                                </TableBody>

                                <TableFooter className={classes.myTableFooter}>
                                    <TableRow key='footer-pasep-total' className="totalPasepLine">
                                        <TableCell align="left">{IS_PASEP_ON ? "PASEP Total" : ""}</TableCell>
                                        <TableCell align="left"></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                        {
                                            IS_PASEP_ON ?
                                                <TableCell align="right">{applyMaskAmount(pasepTotal, true)}</TableCell> : null
                                        }
                                    </TableRow>
                                </TableFooter>

                            </MyTable>
                        </div>
                }

            </div>

            {
                messageBackdrop ?
                    <div className={classes.rightDivBackdrop}>
                        <CircularProgress className={'progress'} />
                        {
                            messageBackdrop != "" ?
                                <Typography variant={'body1'} style={{ marginTop: '16px' }}>
                                    {messageBackdrop}
                                </Typography>
                                : null
                        }

                    </div> : null
            }

        </div>
    );
}